import React from 'react'
import { CONDITION_ITEMS } from '../../constants/conditions'
import listenToClickOutside from 'react-onclickoutside'
import { ConditionName, PeriodConditionName, PeriodParams } from '../../actions'
import DatePickerWrapper from '../date-picker-wrapper'
import { formatPeriodCondition } from '../../utils'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { IcomoonIcon } from '../../../../atoms/IcomoonIcon'
import { parse } from 'date-fns'
import { formatDate } from '@/lib/date'
import { OptionDropdown } from '../../../../view/OptionDropdown'
import { OptionDropdownItem } from '../../../../view/OptionDropdownItem'

type Props = {
  name: PeriodConditionName
  open: boolean
  selected: PeriodParams
  hasError: boolean
  onToggle: (cond: ConditionName) => any
  onRemove: (cond: ConditionName) => any
  onSet: (cond: ConditionName, period: PeriodParams) => any
}

function isListItem(el: any) {
  const cls = el.getAttribute('class')
  return el.tagName === 'LI' && (cls === 'item' || cls === 'item is-selected')
}

class PeriodCondition extends React.Component<Props> {
  handleSet(period: PeriodParams) {
    this.props.onSet(this.props.name, period)
  }

  handleChange(value: any, end: string) {
    const { from, to } = this.props.selected
    const v = value ? formatDate(value.toISOString()) : null
    const period = end == 'from' ? { from: v, to } : { from, to: v }
    this.props.onSet(this.props.name, period)
  }

  handleToggle(target: EventTarget) {
    if (!isListItem(target)) {
      this.props.onToggle(this.props.name)
    }
  }

  handleClickOutside() {
    if (this.props.open) {
      this.props.onToggle(this.props.name)
    }
  }

  renderButton() {
    if (this.props.selected.from || this.props.selected.to) {
      return (
        <span
          onClick={() => this.props.onRemove(this.props.name)}
          css={css`
            margin-left: 5px;
          `}
        >
          <i
            className="icomoon icon-close1 right"
            css={css`
              font-size: 10px;
              color: ${colors.white10};
              &:before {
                font-size: 0.65rem;
                margin-left: 5px;
              }
            `}
          />
        </span>
      )
    } else {
      return (
        <IcomoonIcon
          name="arrow8-down"
          css={css`
            font-size: 10px;
            color: ${colors.white10};
            &:before {
              font-size: 0.65rem;
              margin-left: 5px;
            }
          `}
        />
      )
    }
  }

  renderError() {
    return this.props.hasError ? (
      <i
        className="icomoon icon-alert-fill left"
        css={css`
          &:before {
            margin-right: 3px;
          }
        `}
      />
    ) : null
  }

  render() {
    const { name, selected, hasError } = this.props
    const options = CONDITION_ITEMS[name].options
    const label = CONDITION_ITEMS[name].label
    const errorClass = (c: string = '') => (hasError ? `${c} error` : c)

    return (
      <div
        className={errorClass('condition')}
        css={css`
          background-color: ${colors.cyan50};
          border-radius: 50px;
          color: ${colors.white10};
          display: inline-block;
          font-size: 13px;
          position: relative;
          &.error {
            background-color: ${colors.red50};
          }
        `}
      >
        <li
          className="condition-label"
          onClick={(e) => this.handleToggle(e.target)}
          css={css`
            padding: 5px 10px 5px 15px;
            cursor: pointer;
          `}
        >
          {this.renderError()}
          <span>
            {hasError ? label : formatPeriodCondition(label, selected)}
          </span>
          {this.renderButton()}
        </li>
        <OptionDropdown open={this.props.open}>
          {options.map((option: any, i: any) => (
            <OptionDropdownItem
              key={i}
              idx={i}
              condition={
                selected.from === option.period.from &&
                selected.to === option.period.to
              }
              label={option.label}
              handleSet={() => this.handleSet(option.period)}
            />
          ))}
          <hr
            css={css`
              border-top: 2px solid ${colors.gray30};
              margin: 0;
            `}
          />
          <div
            className="condition-period"
            css={css`
              height: 55px;
              padding: 5px 10px;
              button.error {
                border: 1px solid ${colors.red50};
                color: ${colors.red50};
              }
            `}
          >
            <div
              className="field"
              css={css`
                display: inline-block;
                position: relative;
              `}
            >
              <div
                className="annotation"
                css={css`
                  text-align: left;
                  color: #999;
                  font-size: 12px;
                `}
              >
                (開始)
              </div>
              <DatePickerWrapper
                placeholder="2017-01-01"
                onChange={(v: Date | null) => this.handleChange(v, 'from')}
                selected={
                  this.props.selected.from
                    ? parse(this.props.selected.from, 'yyyy-MM-dd', new Date())
                    : null
                }
                error={this.props.hasError}
              />
            </div>
            <span
              className="divider"
              css={css`
                margin: 25px 5px 5px;
                display: inline-block;
                vertical-align: baseline;
                color: #999;
              `}
            >
              −
            </span>
            <div
              className="field"
              css={css`
                display: inline-block;
                position: relative;
              `}
            >
              <div
                className="annotation"
                css={css`
                  text-align: left;
                  color: #999;
                  font-size: 12px;
                `}
              >
                (終了)
              </div>
              <DatePickerWrapper
                placeholder="2017-01-31"
                onChange={(v: Date | null) => {
                  this.handleChange(v, 'to')
                }}
                selected={
                  this.props.selected.to
                    ? parse(this.props.selected.to, 'yyyy-MM-dd', new Date())
                    : null
                }
                error={this.props.hasError}
              />
            </div>
          </div>
        </OptionDropdown>
      </div>
    )
  }
}
// @ts-ignore
export default listenToClickOutside(PeriodCondition)
